import React from 'react';
import './Badge.css';

export interface BadgeProps {
  /** Badge visual variant */
  variant?:
    | 'default'
    | 'minimal'
    | 'curated'
    | 'ai'
    | 'rating-hard'
    | 'rating-medium'
    | 'rating-easy'
    | 'selection-due'
    | 'selection-semantic'
    | 'selection-new'
    | 'selection-reinforcement'
    | 'deck';
  /** Badge size */
  size?: 'sm' | 'md';
  /** Whether to use pill/round shape */
  round?: boolean;
  /** Badge content */
  children: React.ReactNode;
  /** Additional CSS class */
  className?: string;
}

/**
 * Badge component for labels, tags, and status indicators.
 * Inspired by Blueprint Tag component with compact, professional styling.
 */
export const Badge: React.FC<BadgeProps> = ({
  variant = 'default',
  size = 'md',
  round = false,
  children,
  className = '',
}) => {
  const classes = [
    'stc-badge',
    `stc-badge--${variant}`,
    `stc-badge--${size}`,
    round && 'stc-badge--round',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return <span className={classes}>{children}</span>;
};
